import { createSelector } from '@ngrx/store';
import { featureSelect } from '../settings';
const ɵ0 = (response) => response.errors.errors;
export const getErrors = createSelector(featureSelect, ɵ0);
export { ɵ0 };
